// extracted by mini-css-extract-plugin
export default {"page":"CompanySignUpPage_page__9f3aQ"};